import { useState } from "react";

// import CreditCardIcon from "@mui/icons-material/CreditCard";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import { Button, DialogActions, DialogContent, Paper, Typography } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Tooltip from "@mui/material/Tooltip";
import { siteName } from "@/constants/config";
import usePlatform from "@/hooks/usePlatform";
import useThemeData from "@/hooks/useThemeData";

const PriceGuarantee = () => {

  const bgBlack = "https://img.awardtool-api.com/guides/website-img/bg-alerts-black.jpg";
  const bgWhite = "https://img.awardtool-api.com/guides/website-img/bg-alerts-white.jpg";

  const theme = useThemeData();
  const { isPc } = usePlatform();

  const [visible, setVisible] = useState(false);

  return (
    <Paper
      elevation={1}
      className="!rounded-[4px]"
      style={{
        backgroundColor: theme.isDarkMode ? "#202124" : "#f1f3fb",
      }}
    >
      <div className="flex items-center justify-between h-[70px]">
        <div className="pl-[20px] flex items-center">
          <div className="w-[30px] h-[30px] mr-[10px]">
            <NotificationsActiveIcon color="primary" />
          </div>
          <div>
            <div className="flex items-center">
              <Typography
                sx={{
                  fontWeight: "bold",
                }}
                variant="body1"
              >
                {siteName + " Advanced Alert"}
              </Typography>
              {/* <Chip
                size="small"
                className="ml-[6px]"
                color="primary"
                label="NEW"
                sx={{
                  fontWeight: "bold",
                }}
              /> */}
            </div>
            <Typography className="flex items-center">
              {isPc
                ? "Get updates when your ideal flight and hotel deals are available."
                : "Get updates for your ideal deals."}
              <Tooltip
                sx={{ size: 10 }}
                title="We'll conduct daily searches on your behalf, so you don’t have to. Once the flights that matches your criteria are found, you will get updates immediately. And the alert will be disabled after the first update."
              >
                <InfoOutlinedIcon
                  onClick={() => {
                    if (!isPc) {
                      setVisible(true);
                    }
                  }}
                  sx={{ fontSize: 16, margin: "auto" }}
                />
              </Tooltip>
            </Typography>
          </div>
        </div>

        {isPc && <img className="h-[100%]" src={theme.isDarkMode ? bgBlack : bgWhite} alt="" />}

        <Dialog
          open={visible}
          onClose={() => setVisible(false)}
          PaperProps={{
            sx: {
              borderRadius: "12px",
            },
          }}
        >
          <DialogContent>
            <Typography fontSize={16}>
              We'll conduct daily searches on your behalf, so you don’t have to. Once the flights
              that matche your criteria are found, you will get updates immediately. And the alert
              will be turned off after the first update.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setVisible(false)}>OK</Button>
          </DialogActions>
        </Dialog>
      </div>
    </Paper>
  );
};

export default PriceGuarantee;
